import { render, staticRenderFns } from "./InvestmentSimulation.vue?vue&type=template&id=ee068286&"
import script from "./InvestmentSimulation.vue?vue&type=script&lang=js&"
export * from "./InvestmentSimulation.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentSimulation.vue?vue&type=style&index=0&id=ee068286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports